import { SpcSamplingMethod } from "src/components/views/spc/masterData/controlCharts/form/samplingMethod/SpcSamplingMethod.tsx";
import i18n from "i18next";
import { ControlChartFormRenderProps } from "src/components/views/spc/masterData/controlCharts/form/ControlChartForm.tsx";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import { AsyncFetchRender } from "src/components/common/async/AsyncFetchRender.tsx";
import { toIntOrNull } from "src/utils/strings.tsx";
import { ControlChartCommonApi } from "src/api/generated/spc/controlChart/api/controlChartCommonApi.ts";
import { Skeleton } from "@mui/material";
import { AavoTextField } from "src/components/common/inputFields/AavoTextField.tsx";
import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";
import { faPen } from "@fortawesome/pro-regular-svg-icons";
import { ControlChartSelectionForm } from "src/components/views/spc/controlChart/dataInput/ControlChartSelectionForm.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export const otherControlChartSumOverWorkPeriodSamplingMethod = (): SpcSamplingMethod => {
	return {
		key: "control_chart_sum_per_period",
		label: i18n.t("control_chart_sum_over_work_period"),
		renderParameterFields: (props: ControlChartFormRenderProps) => {
			return <ParameterFields {...props} />;
		},
	};
};

// eslint-disable-next-line react-refresh/only-export-components
const ParameterFields = ({ setValue, watch }: ControlChartFormRenderProps) => {
	const { openDialog } = useGenericDialog();
	return (
		<AsyncFetchRender
			noContainer
			fetch={async () => {
				const chartId = toIntOrNull(watch("samplingParams.param1"));
				if (chartId == null) return null;

				return await ControlChartCommonApi.getControlChart({
					controlChartId: chartId,
				});
			}}
			skeleton={
				<>
					<Skeleton
						key={"controlChartNameSkeleton"}
						variant="rounded"
						sx={{
							alignSelf: "stretch",
							width: 100,
							height: "initial",
						}}
					/>
				</>
			}
			content={(controlChart, reload) => (
				<>
					<AavoTextField
						value={controlChart?.name}
						label={i18n.t("control_chart_to_sum")}
						disabled
						slotProps={{
							input: {
								endAdornment: (
									<AsyncButton
										icon={faPen}
										onClick={() =>
											openDialog(({ closeDialog }) => ({
												title: i18n.t("select_control_chart"),
												size: "sm",
												agentContext: {
													key: defineAgentUiContextKey(
														"spc.samplingMethod.selectControlChart.dialog",
													),
													data: {
														currentControlChartId:
															toIntOrNull(watch("samplingParams.param1")) ?? null,
													},
													pathSegments: [i18n.t("select_control_chart")],
												},
												content: (
													<ControlChartSelectionForm
														currentControlChartId={
															toIntOrNull(watch("samplingParams.param1")) ?? undefined
														}
														onSubmit={async (controlChart) => {
															setValue(
																"samplingParams.param1",
																controlChart?.chartId.toString(),
															);
															await reload();
														}}
														closeDialog={closeDialog}
													/>
												),
											}))
										}
									/>
								),
							},
						}}
					/>
				</>
			)}
		/>
	);
};
